import ModalShell from "../modalShell/ModalShell";
import Typography from "../typography/Typography";
import styles from "./infoDialog.module.scss";

interface InfoDialogProps {
  open: boolean;
  title?: string;
  body?: string;
  onClose: () => void;
}

export default function InfoDialog({ open, title, body, onClose }: InfoDialogProps): JSX.Element | null {
  return (
    <ModalShell open={open} title={title} onClose={onClose}>
      {body && <Typography className={styles.description}>{body}</Typography>}
    </ModalShell>
  );
}
